module.exports = {
  socketIo: "https://api2.devs.automate.video",
  playerkey: "SDFJIWR3sssdgwwerweWLK23423424!sldkfj9s49g499g4cccf",
  debug: true,
};
